var app = angular.module('leonardo');

var TaskDynamicFormDialogReact = function (
  $scope,
  $q,
  formObj,
  formDataObj,
  FilterService,
  PropertyService,
  AuthDataService,
  UnitService,
  $element,
  ConfigThemeService,
  ngDialog,
  AccountUserService,
  AnalyticsService
) {
  $scope.reactSubmissionCallback = function (action, data, newTask) {
    switch (action) {
      case 'skip':
        $scope.confirm('skip');
        break;
      case 'close':
        $scope.closeThisDialog({df_attachments_note: $scope.df_attachments_note, df_comments: $scope.ngDialogData.df_comments });
        break;
      default:
        $scope.confirm({ dynamic_form_data: data, task: newTask, df_attachments_note: $scope.df_attachments_note, df_comments: $scope.ngDialogData.df_comments });
        break;
    }
  };
  $scope.getPreferredLanguage = function (){
    let preferred_language = _.cloneDeep(AuthDataService.authData.user.preferred_language);
    if(preferred_language && Object.keys(preferred_language).length > 0){
      preferred_language = preferred_language.code;
    }
    return preferred_language;
  }

  $scope.getAvailableLanguages = function (){
    var user_account_id = ((AccountUserService.currentAccountUser.account && AccountUserService.currentAccountUser.account.id) ?
    AccountUserService.currentAccountUser.account.id : AccountUserService.currentAccountUser.account);
    angular.forEach(AuthDataService.authData.accountsManager, function(manager) {
      if (manager.id == user_account_id){
        $scope.availableLanguages = manager.languages
      }
    });

  }

  $scope.workOrderAnalyticsHandler = function (data) {
    AnalyticsService.track('Work Order Created', 
      {
        ...AnalyticsService.getWorkOrderGroupProperties(data),
        portfolio_id: FilterService.currentPortfolio ? FilterService.currentPortfolio.id : null,
        context: 'dynamic form',
      }
       
    )
  }
  $scope.loadReact = function () {
    if (!$element.find('#react-form')[0]) {
      return;
    }
    var el = React.createElement(window.LfaScreen, {
      data: {
        df: formObj,
        dfData: formDataObj,
        unit: $scope.unit,
        property: $scope.property,
        task: $scope.task.id,
        print: $scope.ngDialogData.print,
        user: $scope.ngDialogData.force && (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) ? null : AuthDataService.authData.user,
        workflow: $scope.workflow,
        template: $scope.task.template ? $scope.task.template.id || $scope.task.template : null,
        status: $scope.task.status,
        approvalStatus: $scope.ngDialogData.approvalStatus,
        force: $scope.ngDialogData.force,
        filters: $scope.filters,
        preferred_language: $scope.getPreferredLanguage(),
      },
      submissionCallback: $scope.reactSubmissionCallback,
      configTheme: { config: ConfigThemeService.config, updated: ConfigThemeService.updated },
      availableLanguages: $scope.availableLanguages,
      workOrderAnalyticsHandler: $scope.workOrderAnalyticsHandler
    });
    ReactDOM.render(el, $element.find('#react-form')[0]);
  };
  $scope.showAttachNoteFileDialog = function () {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/attachment/upload.html',
      controller: 'AttachmentUploadDialog',
      data: { task: {}, mode: 'upload_note' }
    }).then(function (attachments) {
      angular.forEach(attachments, function (attachment) {
        $scope.df_attachments_note.push(attachment);
      });
    }, function () {
      return;
    });
  };

  $scope.removeAttachmentNote = function (index) {
    $scope.df_attachments_note.splice(index, 1);
  };

  $scope.dynamic_form = formObj;
  $scope.df_attachments_note = $scope.ngDialogData.attachments || [];
  $scope.filters = $scope.ngDialogData.filters || {};
  if($scope.ngDialogData.approvalStatus) {
    $scope.closepopup = function() {
      $scope.closeThisDialog({df_attachments_note: $scope.df_attachments_note, df_comments: $scope.ngDialogData.df_comments });
    }
  }

  if ($scope.ngDialogData.property) {
    $scope.property = $scope.ngDialogData.property;
  } else {
    $scope.propertyName = FilterService.currentProperty ? FilterService.currentProperty.name : '';
    $scope.property = FilterService.currentProperty ? PropertyService.get(FilterService.currentProperty.id) : null;
  }
  if (!$scope.property) {
    $scope.property = PropertyService.get(FilterService.currentProperty.id);
  }

  $scope.promises = [$scope.ngDialogData.task, $scope.property];

  $q.all($scope.promises).then(function (results) {
    $scope.task = results[0];
    $scope.property = results[1];
    $scope.unit = $scope.task && $scope.task.workflow_instance ? $scope.task.workflow_instance.unit : null;
    $scope.workflow = $scope.task && $scope.task.workflow_instance ? $scope.task.workflow_instance.workflow : null;
    $scope.workflow_instance = $scope.task && $scope.task.workflow_instance ? $scope.task.workflow_instance : null;
    var defer = $q.defer();
    if ($scope.unit) {
      var params = angular.copy($scope.filters);
      if ($scope.ngDialogData.force) {
        params.with_deleted = true;
      }
      if ($scope.workflow_instance && $scope.workflow_instance.id) {
        params['workflowinstanceID'] = $scope.workflow_instance.id;
        params['fetch_resident'] = true;
      }
      UnitService.one($scope.unit.id)
        .get(params)
        .then(function (data) {
          $scope.unit = data;
          defer.resolve();
        });
    } else {
      defer.resolve();
    }
    defer.promise.then(function () {
      $scope.propertyName = $scope.property.name;
      $scope.getAvailableLanguages();
      $scope.loadReact();
    });
  });

  $scope.$on('$destroy', function () {
    if(CKEDITOR.instances?.df_text?.commands?.maximize?.state === 1){
      CKEDITOR.instances.df_text.execCommand( 'maximize' ) 
    }
    $('#commnent-box').remove();
    if (!$element.find('#react-form')[0]) {
      return;
    }
    ReactDOM.unmountComponentAtNode($element.find('#react-form')[0]);
  });
};

app.controller('TaskDynamicFormDialogReact', [
  '$scope',
  '$q',
  'formObj',
  'formDataObj',
  'FilterService',
  'PropertyService',
  'AuthDataService',
  'UnitService',
  '$element',
  'ConfigThemeService',
  'ngDialog',
  'AccountUserService',
  'AnalyticsService',
  TaskDynamicFormDialogReact
]);
